import { ApiError } from './api-error';

/**
 * Single HTTP entry point for the gym client. Always targets the relative
 * `/api/v1` base (proxied to the API in development, same-site in
 * production) and always sends the session cookie. `fetchImpl` is injectable
 * so tests assert on the observable request/response instead of mocking the
 * global `fetch`.
 */
export async function apiRequest(path, { method = 'GET', body, signal, fetchImpl = fetch } = {}) {
  let response;
  try {
    response = await fetchImpl(`/api/v1${path}`, {
      method,
      credentials: 'include',
      signal,
      headers: body === undefined ? undefined : { 'Content-Type': 'application/json' },
      body: body === undefined ? undefined : JSON.stringify(body),
    });
  } catch (cause) {
    // A deliberate abort (e.g. navigating away, unmounting) is not a
    // failure the UI should present as "no se pudo conectar"; let it
    // propagate so callers can distinguish it from a real network error.
    if (cause && cause.name === 'AbortError') throw cause;
    // Any other transport failure (DNS, offline, CORS, connection reset...)
    // reaches here as a raw rejection from fetch, e.g. `TypeError("Failed to
    // fetch")`. Never show that raw text to the user; normalize it the same
    // way as any other API failure.
    throw new ApiError(0, 'network_error', 'No se pudo conectar con el servidor. Revisá tu conexión e intentá de nuevo.');
  }
  if (response.status === 204) return null;
  const payload = await response.json().catch(() => null);
  if (!response.ok) throw ApiError.fromResponse(response.status, payload);
  return payload;
}
